/* eslint-disable require-jsdoc */
import moment from 'moment';


function currDate() {
  let today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
  const yyyy = today.getFullYear();
  today = yyyy + '-' + mm + '-' + dd;
  return today;
}

const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
function getWeekDay(day) {
  return weekDays[parseInt(day) - 1];
};
const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];
function getMonth(month) {
  return months[parseInt(month) - 1];
};

const todaysDate = () => {
  const today = moment();
  const dd = today.clone().format('DD');
  const mm = today.clone().format('MM');
  const yyyy = today.clone().format('YYYY');
  const todayFormatted = yyyy + '-' + mm + '-' + dd;
  // console.log('today date is:', todayFormatted);
  return todayFormatted;
};

const futureDates = (chosenDay) => {
  const today = moment();
  let dd;
  let mm;
  let yyyy;
  let userChosenFutureDate = yyyy + '-' + mm + '-' + dd;

  switch (chosenDay) {
    case 'day':
      dd = today.clone().format('DD');
      mm = today.clone().format('MM');
      yyyy = today.clone().format('YYYY');
      userChosenFutureDate = yyyy + '-' + mm + '-' + dd;
      break;

    case 'week':
      dd = today.clone().add(1, 'week').format('DD');
      mm = today.clone().add(1, 'week').format('MM');
      yyyy = today.clone().add(1, 'week').format('YYYY');
      userChosenFutureDate = yyyy + '-' + mm + '-' + dd;
      break;

    case 'two_week':
      dd = today.clone().add(2, 'week').format('DD');
      mm = today.clone().add(2, 'week').format('MM');
      yyyy = today.clone().add(2, 'week').format('YYYY');
      userChosenFutureDate = yyyy + '-' + mm + '-' + dd;
      break;

    case 'month':
      dd = today.clone().add(1, 'month').format('DD');
      mm = today.clone().add(1, 'month').format('MM');
      yyyy = today.clone().add(1, 'month').format('YYYY');
      userChosenFutureDate = yyyy + '-' + mm + '-' + dd;
      break;

    default:
      userChosenFutureDate = '2021-01-01';// this will never be called
      break;
  }
  // console.log('userChosenFutureDate is:', userChosenFutureDate);
  return userChosenFutureDate;
};

export {currDate, getMonth, getWeekDay, todaysDate, futureDates};
